import { useGetApprovalItemQuery } from 'features/comments/approvalApi';

/**
 * @param {string} uri
 * @returns {import('models/approval.models').ApprovalItem | undefined}
 */
export function useGetApprovalItem(uri) {
    const results = useGetApprovalItemQuery(uri, {
        skip: uri === undefined,
    });

    return results?.currentData;
}
